import { ReactElement } from "react"
import { makeStyles } from "tss-react/mui"
import { Box, Typography } from "@mui/material"
import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const useStyles = makeStyles()((theme) => ({
    header: {
        display: "flex",
        alignItems: "center",
        gap: ".5rem",
        marginBottom: "1rem",
    },
    iconBox: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    icon: {
        fontSize: "1.125rem",
        color: theme.palette.tailwind.slate[500],
    },
    title: {
        color: theme.palette.tailwind.slate[900],
    },
}))

type TakeawayCheckoutSectionHeaderProps = Readonly<{
    icon?: IconDefinition
    title: ReactElement
}>

export function TakeawayCheckoutSectionHeader({ icon, title }: TakeawayCheckoutSectionHeaderProps) {
    const { classes } = useStyles()

    return (
        <Box className={classes.header}>
            {icon && (
                <Box className={classes.iconBox}>
                    <FontAwesomeIcon icon={icon} className={classes.icon} />
                </Box>
            )}
            <Typography variant="h6" className={classes.title}>
                {title}
            </Typography>
        </Box>
    )
}
